const configs = {
  stage: require("./stage.json"),
  production: require("./production.json")
};

const getConfig = env => {
  return configs[env];
};

module.exports = {
  getConfig
};
